import router from '@/router';
import store from '@/store';

import {
    getCanAnswerFeedback,
    getSubscriptionLastFeedbackSeen,
    updateRatingLastSeen,
    updateRatingLastSeenContractor
} from '@/services';

const setBackgroundColor = to => {
    const bgGrey = 'bg-grey';
    if (to.matched.some(record => record.meta.backgroundGrey)) {
        document.body.classList.add(bgGrey);
    } else {
        document.body.classList.remove(bgGrey);
    }
};

const userInformation = async () => {
    const hasUser = await store.dispatch('user/hasUser');
    let isRequester = false;
    let isCondoAdministrator = false;
    let isSupplier = false;
    if (store.state.user.user.type) {
        isCondoAdministrator = store.state.user.user.type.isCondoAdministrator;
        isRequester = store.state.user.user.type.isRequester;
        isSupplier = store.state.user.user.type.isSupplier;
    }
    return { hasUser, isRequester, isCondoAdministrator, isSupplier };
};

const middlewareUsers = async (to, next) => {
    const { hasUser, isRequester, isCondoAdministrator, isSupplier } = await userInformation();
    if (to.matched.some(record => record.meta.requireAuth)) {
        // ações de bloqueio em rotas por tipos de usuários
        if (to.name == 'CompetitionDashboardGuest') {
            next({ name: 'CompetitionDashboard' });
        } else if (hasUser) {
            if ((isCondoAdministrator || isRequester) && to.name == 'Home') {
                // se ele tiver logado, verificamos o tipo do usuário e fazemos alguma coisa
                router.push({ name: 'ListCompetitions' }).catch(() => {});
            } else {
                next();
            }
            // Tentando acessar detalhes de uma cotação, não estando logado
            // vamos levar ele para o detalhe de cotação visitante
        } else if (!hasUser && to.name == 'OffersDetails') {
            router.push({ name: 'OffersDetailsGuest' });
        } else {
            // Se o fornecedor tentar acessar uma página que requer autenticação
            // sem está logado, vamos salvar essa rota para manda-lo de volta
            store.dispatch('router/setRedirectUrl', to.fullPath);
            next('/entrar');
        }
    } else if ((to.name == 'Login' || to.name == 'Signup') && hasUser) {
        next('/inicio');
    } else if (isSupplier && to.name == 'OffersDetailsGuest') {
        /* Redirecionando a tela de detalhes da cotação caso esteja logado */
        router.push({ name: 'OffersDetails', params: { tag: to.params.tag, id: to.params.id } }).catch(() => {});
    } else {
        next();
    }
};

const checkFeedback = async (to, next) => {
    const { isSupplier } = await userInformation();
    if (
        to.matched.some(record => record.meta.requireAuth) &&
        to.name !== 'Home' &&
        !store.state.user.canAnswerFeedback
    ) {
        // se for com meta de logado
        // se não for a rota home
        // se não respondeu o feedback
        // se está na rota que tem que mostrar o feedback
        if (to.name === 'ListCompetitions' || to.name === 'CompetitionDashboard') {
            // faz a chamada e verifica se tem que abrir o modal
            let canAnswerFeedback;
            if (isSupplier) {
                const { supplierLastSeen } = await getSubscriptionLastFeedbackSeen();
                try {
                    const data = {
                        last_time_seen_feedback: new Date()
                    };
                    await updateRatingLastSeen(data);
                } catch (e) {
                    console.log(e);
                }
                canAnswerFeedback = supplierLastSeen.canAnswerFeedback;
            } else {
                const { contractorLastSeen } = await getCanAnswerFeedback();
                try {
                    const data = {
                        last_time_seen_feedback: new Date()
                    };
                    await updateRatingLastSeenContractor(data);
                } catch (e) {
                    console.log(e);
                }
                canAnswerFeedback = contractorLastSeen.canAnswerFeedback;
            }
            store.dispatch('user/ratingFeedback', canAnswerFeedback);
        }
    }
};

export const mainMiddleware = async (to, from, next) => {
    setBackgroundColor(to);
    checkFeedback(to, next);
    middlewareUsers(to, next);
};
